// removed by extract-text-webpack-plugin
module.exports = {"primary":"_2C-J2aT5vQhqqmCI8qk-_B"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ChangePassword/index.less
// module id = 746
// module chunks = 0